// Generated by Melange

import * as Buhta_components__CopyButton from "../../../../../../../packages/components/src/CopyButton.js";
import * as Buhta_components__CopyButton24 from "../../../../../../../packages/components/src/CopyButton24.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function ClassifiersUnitView(Props) {
  let units = Props.units;
  let id = Props.id;
  let unit;
  try {
    unit = Stdlib__List.find((function (a) {
      return a.code === id;
    }), units);
  }
  catch (exn){
    unit = {
      country: /* COUNTRY_KAZ */ 1,
      code: "",
      name: "",
      short_name: "",
      alternative: /* [] */ 0
    };
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs(Buhta_landing__Link.make, {
        route: {
          TAG: /* Landing */ 0,
          _0: /* COUNTRY_KAZ */ 1,
          _1: /* Ru */ 1,
          _2: {
            TAG: /* Classifiers */ 8,
            _0: {
              TAG: /* Unit */ 3,
              _0: /* List */ 0
            }
          }
        },
        className: "flex gap-2 items-center",
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6",
            src: StaticAsset.src("/static/icons/arrow-back-black-24.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "На главную",
            className: "paragraph text-gray-medium"
          })
        ],
        scrollToTop: false
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h6", {
            children: unit.name,
            className: "h6 text-black-landing"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_components__CopyButton24.make, {
              text: unit.name
            }),
            className: "lg:opacity-0 group-hover:opacity-100 shrink-0"
          })
        ],
        className: "flex px-2 py-1 hover:bg-gray-pale mt-10 items-end gap-2 group rounded-md w-fit"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Условное обозначение",
                className: "paragraph-small text-gray-light-landing px-2 py-1"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: unit.short_name,
                      className: "paragraph text-black-landing"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                        text: unit.short_name
                      }),
                      className: "lg:opacity-0 group-hover:opacity-100 shrink-0"
                    })
                  ],
                  className: "flex px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit"
                })
              }),
              JsxRuntime.jsx("p", {
                children: "Международный код",
                className: "paragraph-small text-gray-light-landing px-2 py-1"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: "-",
                      className: "paragraph text-black-landing"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                        text: "-"
                      }),
                      className: "lg:opacity-0 group-hover:opacity-100 shrink-0"
                    })
                  ],
                  className: "flex px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit"
                })
              })
            ],
            className: "grid grid-cols-[max-content_auto] gap-x-2 items-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Код единицы измерения ESF",
                className: "paragraph-small text-gray-light-landing px-2 py-1"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: unit.code,
                      className: "paragraph text-black-landing"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                        text: unit.code
                      }),
                      className: "lg:opacity-0 group-hover:opacity-100 shrink-0"
                    })
                  ],
                  className: "flex px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit"
                })
              }),
              JsxRuntime.jsx("p", {
                children: "Код единицы измерения МКЕИ",
                className: "paragraph-small text-gray-light-landing px-2 py-1"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: unit.code,
                      className: "paragraph text-black-landing"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                        text: unit.code
                      }),
                      className: "lg:opacity-0 group-hover:opacity-100 shrink-0"
                    })
                  ],
                  className: "flex px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit"
                })
              }),
              JsxRuntime.jsx("p", {
                children: "Код единицы измерения ОКЕИ",
                className: "paragraph-small text-gray-light-landing px-2 py-1"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: unit.code,
                      className: "paragraph text-black-landing"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                        text: unit.code
                      }),
                      className: "lg:opacity-0 group-hover:opacity-100 shrink-0"
                    })
                  ],
                  className: "flex px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit"
                })
              }),
              JsxRuntime.jsx("p", {
                children: "Код единицы измерения ТИС",
                className: "paragraph-small text-gray-light-landing px-2 py-1"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: unit.code,
                      className: "paragraph text-black-landing"
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                        text: unit.code
                      }),
                      className: "lg:opacity-0 group-hover:opacity-100 shrink-0"
                    })
                  ],
                  className: "flex px-2 py-1 hover:bg-gray-pale items-end gap-1 group rounded-md w-fit"
                })
              })
            ],
            className: "grid grid-cols-[max-content_auto] gap-x-2 items-center"
          })
        ],
        className: "mt-4 lg:mt-6 lg:flex lg:gap-20 items-start"
      })
    ]
  });
}

const make = ClassifiersUnitView;

export {
  make,
}
/* Buhta_components__CopyButton Not a pure module */
